import React, { useState, useEffect } from "react";

import { ThemeProvider, useTheme } from "styled-components";

import EmptyState from "../../../components/empty-state/EmptyState";
import Overview from "./overview/Overview";
import AnnouncementsEditor from "../../../features/announcements/components/editor/AnnouncementsEditor";
import ButtonEditor from "../../../features/button-block/components/editor/ButtonEditor";
import CardsEditor from "../../../features/cards-v2/components/editor/CardsEditor";
import PanelSimpleEditor from "../../../features/panel-simple/components/editor/PanelSimpleEditor";
import CountdownEditor from "../../../features/countdown/components/editor/CountdownEditor";
import SpacerAndDividerEditor from "../../../features/spacer-and-divider/components/editor/SpacerAndDividerEditor";
import TitleAndTextEditor from "../../../features/title-and-text/components/editor/TitleAndTextEditor";
import ImageSliderEditor from "../../../features/image-slider-new/components/editor/ImageSliderEditor";
import AdvancedTabsGroupEditor from "../../../features/advanced-tabs/group/components/editor/AdvancedTabsGroupEditor";
import FootnoteDisplayEditor from "../../../features/footnote-display/editor/FootnoteDisplayEditor";
import TooltipFootnoteEditor from "../../../features/tooltip-and-footnote/editor/TooltipFootnoteEditor";
import AdvancedTabsSingleEditor from "../../../features/advanced-tabs/single/components/editor/AdvancedTabsSingleEditor";
import PanelAdvancedEditor from "../../../features/panel-advanced/components/editor/PanelAdvancedEditor";
import ButtonInlineEditor from "../../../features/button-inline/editor/ButtonInlineEditor";
import EasyHTMLEditor from "../../../features/easy-html/editor/EasyHTMLEditor";
import Toolbar from "../toolbar/Toolbar";
import Columns from "../toolbar/components/Columns";
import GlobalUndoRedo from "../toolbar/components/GlobalUndoRedo";
import GroupCards from "../toolbar/components/GroupCards";
import ModeSwitcher from "../drawers/settings/features/html/ModeSwitcher";
import { MACRO_KEY } from "../../defaults";
import { ContentContainer } from "./styles";
import { EMPTY_STATE_KEY } from "../../../components/empty-state/templates";
import { macroStores } from "../../../stores/export-stores";
import { useOpticsStore } from "../../../stores/use-optics-store";

const editorComponents = {
  [MACRO_KEY.BUTTON]: ButtonEditor,
  [MACRO_KEY.BUTTON_INLINE]: ButtonInlineEditor,
  [MACRO_KEY.CARDS]: CardsEditor,
  [MACRO_KEY.PANEL_SIMPLE]: PanelSimpleEditor,
  [MACRO_KEY.ANNOUNCEMENTS]: AnnouncementsEditor,
  [MACRO_KEY.COUNTDOWN]: CountdownEditor,
  [MACRO_KEY.SPACER_AND_DIVIDER]: SpacerAndDividerEditor,
  [MACRO_KEY.TEXT_AND_TITLE]: TitleAndTextEditor,
  [MACRO_KEY.IMAGE_SLIDER]: ImageSliderEditor,
  [MACRO_KEY.ADVANCED_TABS_GROUP]: AdvancedTabsGroupEditor,
  [MACRO_KEY.FOOTNOTE_DISPLAY]: FootnoteDisplayEditor,
  [MACRO_KEY.TOOLTIPS_AND_FOOTNOTES]: TooltipFootnoteEditor,
  [MACRO_KEY.ADVANCED_TABS_SINGLE]: AdvancedTabsSingleEditor,
  [MACRO_KEY.PANEL_ADVANCED]: PanelAdvancedEditor,
  [MACRO_KEY.HTML]: EasyHTMLEditor,

  [MACRO_KEY.OVERVIEW_KEY]: Overview,
};

const toolbarComponents = {
  [MACRO_KEY.BUTTON]: {
    ThirdComponent: GlobalUndoRedo,
  },
  [MACRO_KEY.BUTTON_INLINE]: {
    ThirdComponent: GlobalUndoRedo,
  },
  [MACRO_KEY.CARDS]: {
    FirstComponent: GroupCards,
    SecondComponent: Columns,
    ThirdComponent: GlobalUndoRedo,
  },
  [MACRO_KEY.PANEL_SIMPLE]: {
    ThirdComponent: GlobalUndoRedo,
  },
  [MACRO_KEY.ANNOUNCEMENTS]: {
    SecondComponent: Columns,
    ThirdComponent: GlobalUndoRedo,
  },
  [MACRO_KEY.COUNTDOWN]: {
    ThirdComponent: GlobalUndoRedo,
  },
  [MACRO_KEY.SPACER_AND_DIVIDER]: {
    ThirdComponent: GlobalUndoRedo,
  },
  [MACRO_KEY.TEXT_AND_TITLE]: {
    ThirdComponent: GlobalUndoRedo,
  },
  [MACRO_KEY.IMAGE_SLIDER]: {
    ThirdComponent: GlobalUndoRedo,
  },
  [MACRO_KEY.ADVANCED_TABS_GROUP]: {
    ThirdComponent: GlobalUndoRedo,
  },
  [MACRO_KEY.ADVANCED_TABS_SINGLE]: {
    ThirdComponent: GlobalUndoRedo,
  },
  [MACRO_KEY.PANEL_ADVANCED]: {
    ThirdComponent: GlobalUndoRedo,
  },
  [MACRO_KEY.HTML]: {
    SecondComponent: ModeSwitcher,
  },
};

const Content = () => {
  const [selectedTheme, setSelectedTheme] = useState();

  const macro = useOpticsStore((state) => state.macro);

  const theme = useTheme();

  useEffect(() => {
    window.AP.events.on("theme-changed", setSelectedTheme);
  }, []);

  const macroHasData = macroStores[macro]?.((state) =>
    Array.isArray(state?.data)
      ? !!state?.data?.length
      : !!Object.keys(state?.data || {}).length
  );

  const EditorComponent =
    editorComponents[macro] ||
    (() => <EmptyState template={EMPTY_STATE_KEY.GETTING_STARTED} />);

  const toobalProps = toolbarComponents[macro] || {};

  return (
    <ThemeProvider theme={selectedTheme || theme}>
      <ContentContainer>
        {macroHasData && <Toolbar {...toobalProps} />}
        {macroHasData || macro === MACRO_KEY.OVERVIEW_KEY ? (
          <EditorComponent />
        ) : (
          <EmptyState template={EMPTY_STATE_KEY.NO_TEMPLATE} />
        )}
      </ContentContainer>
    </ThemeProvider>
  );
};

export default Content;
